import { DivIcon, DivIconOptions } from "leaflet";

export interface BackgroundImageIconOptions extends DivIconOptions {
  pictoUrl?: string;
  pictoClasses?: string;
}

export class BackgroundImageIcon extends DivIcon {

  declare options: BackgroundImageIconOptions;

  constructor(options?: BackgroundImageIconOptions) {
    super(options);
    options.pictoUrl = options.pictoUrl || null;
    options.pictoClasses = options.pictoClasses || null;
    options.html = options.html || null;
    this.options = options;
  }

  createIcon(oldIcon?: HTMLElement): HTMLElement {
    var icon = super.createIcon(oldIcon);

    if (this.options.iconUrl) {
      icon.style.maskImage = `url(${this.options.iconUrl})`;
    }

    if (this.options.pictoUrl) {
      var pictoSpan = document.createElement('i')
      pictoSpan.style.maskImage = `url(${this.options.pictoUrl})`;
      pictoSpan.style.webkitMaskImage = `url(${this.options.pictoUrl})`;
      pictoSpan.classList.add('marker-inside-picto');

      if (this.options.pictoClasses) {
        pictoSpan.classList.add(...this.options.pictoClasses.split(' '));
      }
      icon.appendChild(pictoSpan);
    }
    return icon;
  }
}
